

























































import {Vue, Component} from 'vue-property-decorator';
import {
  GetDepartmentsService,
  PutDepartmentsDisplayOrderRequest,
  PostDepartmentsRequest,
  DeleteDepartmentsRequest,
  PutDepartmentsRequest,
  PutDepartmentsValidation,
  PostDepartmentsValidation,
  PostDepartmentsGroup
} from 'supporter';
import { pattern } from '@/const/regex'
@Component({})
export default class ChildAdminDepartment extends Vue {
  private errorDepart: boolean = false;
  private formEdited: boolean = false;
  private GetDepartmentsData: GetDepartmentsService[] = [];
  private selectedDepartmentsData: GetDepartmentsService | {} = {};
  private indexGetDepartmentsService: number = 1;
  private displayInput = {}
  // private addedDepartmentGroup: {} = {};
  private addedDepartmentGroup: PostDepartmentsGroup | null = null;
  private async tabChanged() {
    const {departmentNo} = this.selectedDepartmentsData as GetDepartmentsService;
    if (departmentNo) {
      const selectedDepartmentsData = this.selectedDepartmentsData as GetDepartmentsService;
      const putRequest: PutDepartmentsRequest = {
        pathParams: {
          departmentNo: selectedDepartmentsData.departmentNo.toString()
        },
        data: {
          departmentName: selectedDepartmentsData.departmentName.toString()
        }
      };
      const validationResult = PutDepartmentsValidation(putRequest);
      if (validationResult.length) {
        this.formEdited = false;
        alert(this.$t(`ADMIN_DEPARTMENT_${validationResult[0].message}`));
        `        this.$api.getDepartments().then((ret: GetDepartmentsResponse) => {
          if (ret && ret.data) {
            this.GetDepartmentsData = ret.data;
            this.addedDepartmentGroup = null;
            this.selectedDepartmentsData = this.GetDepartmentsData[this.indexGetDepartmentsService];
            this.indexGetDepartmentsService = this.indexGetDepartmentsService;
          }
        });`;
        this.formEdited = true;
      } else {
        if (window.confirm(`${this.$t('ADMIN_DEPARTMENT_UPDATE_WHETHER')}`)) {
          this.$api.putDepartments(putRequest).then(() => {
            this.$api.getDepartments().then((ret) => {
              if (ret && ret.data) {
                this.GetDepartmentsData = ret.data;
                this.addedDepartmentGroup = null;
                this.selectedDepartmentsData = this.GetDepartmentsData[0];
                this.indexGetDepartmentsService = 0;
                this.formEdited = false;
                // this.setDepartmentsData(this.GetDepartmentsData[0], this.indexGetDepartmentsService);
                alert(this.$t('ADMIN_DEPARTMENT_UPDATE_SUCCESS'));
              }
            });
          });
          return true;
        } else {
          return false;
        }
      }
    } else {
      const selectedDepartmentsData = this.selectedDepartmentsData as GetDepartmentsService;
      const postRequest: PostDepartmentsRequest = {
        data: {
          departmentName: selectedDepartmentsData.departmentName.toString()
        }
      };
      const validationResult = PostDepartmentsValidation(postRequest);
      if (validationResult.length) {
        this.formEdited = false;
        alert(this.$t(`ADMIN_DEPARTMENT_${validationResult[0].message}`));
        const text = this.$t('ADMIN_DEPARTMENT_NEW_GROUP');
        const departmentsData = {
          departmentName: text.toString()
        };
        this.addedDepartmentGroup = departmentsData;
        this.setDepartmentsData(this.addedDepartmentGroup, this.GetDepartmentsData.length);
        this.formEdited = true;
      } else {
        if (window.confirm(`${this.$t('ADMIN_DEPARTMENT_UPDATE_WHETHER')}`)) {
          this.$api.postDepartments(postRequest).then(() => {
            this.$api.getDepartments().then((ret) => {
              if (ret && ret.data) {
                this.GetDepartmentsData = ret.data;
                this.addedDepartmentGroup = null;
                this.selectedDepartmentsData = this.GetDepartmentsData[0];
                this.indexGetDepartmentsService = 0;
                this.formEdited = false;
                // this.setDepartmentsData(this.GetDepartmentsData[0], this.indexGetDepartmentsService);
                alert(this.$t('ADMIN_DEPARTMENT_UPDATE_SUCCESS'));
              }
            });
          });
          return true;
        } else {
          return false;
        }
      }
    }
  }
  private created() {
    this.$api.getDepartments().then((ret) => {
      if (ret && ret.data) {
        this.GetDepartmentsData = ret.data;
        this.setDepartmentsData(this.GetDepartmentsData[0], 0);
      }
    });
    // const selectedDepartmentsData = this.selectedDepartmentsData as GetDepartmentsService;
  }
  private selectStatus: any = {};
  private setDepartmentsData(departmentsData: any, index: any): void {
    // 深复制 获取选中的名字 在更改名称是 如果为空 使用原来的名字
    Object.assign(this.selectStatus, departmentsData);
    if (this.formEdited) {
      alert(this.$t('ADMIN_DEPARTMENT_CONFIRM'));
      return;
    }
    this.selectedDepartmentsData = departmentsData;
    this.indexGetDepartmentsService = index;
    this.formEdited = false;
  }
  private displayChange(direction: string) {
    const selectedDepartmentsData = this.selectedDepartmentsData as GetDepartmentsService;

    if (direction == 'DOWN') {
      if (this.indexGetDepartmentsService == this.GetDepartmentsData.length - 1) {
        this.indexGetDepartmentsService = this.GetDepartmentsData.length - 1;
        // alert(this.$t('ADMIN_DEPARTMENT_ERRMESSAGE'));
      } else {
        this.indexGetDepartmentsService += 1;
      }
    } else {
      if (this.indexGetDepartmentsService == 0) {
        this.indexGetDepartmentsService = 0;
        // alert(this.$t('ADMIN_DEPARTMENT_ERRMESSAGE'));
      } else {
        this.indexGetDepartmentsService -= 1;
      }
    }
    if (selectedDepartmentsData.hasOwnProperty('departmentNo') && !this.formEdited) {
      const putRequest: PutDepartmentsDisplayOrderRequest = {
        pathParams: {
          departmentNo: JSON.stringify(selectedDepartmentsData.departmentNo)
        },
        data: {
          // newOrder: direction == 'DOWN' ? ++this.indexGetDepartmentsService : --this.indexGetDepartmentsService
          newOrder: direction == 'DOWN' ? Math.min(this.indexGetDepartmentsService, this.GetDepartmentsData.length - 1) : Math.max(this.indexGetDepartmentsService, 0)
        }
      };
      this.$api.putDepartmentsDisplayOrder(putRequest).then(() => {
        this.$api.getDepartments().then((ret) => {
          if (ret && ret.data) {
            this.GetDepartmentsData = ret.data;
            // this.setDepartmentsData(this.GetDepartmentsData[0], this.indexGetDepartmentsService);
          }
        });
      });
    } else {
      alert(this.$t('ADMIN_DEPARTMENT_CONFIRM'));
    }
  }
  private addGroup() {
    const text = this.$t('ADMIN_DEPARTMENT_NEW_GROUP');
    const departmentsData = {
      departmentName: text.toString()
    };
    this.addedDepartmentGroup = departmentsData;

    this.setDepartmentsData(this.addedDepartmentGroup, this.GetDepartmentsData.length);
    this.formEdited = true;
  }
  private deleteGroup() {
    const selectedDepartmentsData = this.selectedDepartmentsData as GetDepartmentsService;
    if (selectedDepartmentsData.departmentNo) {
      if (confirm(this.$t('ADMIN_DEPARTMENT_DEPARTMENT_DELETE').toString())) {
        if (selectedDepartmentsData.hasOwnProperty('departmentNo')) {
          const deleteRequest: DeleteDepartmentsRequest = {
            pathParams: {
              departmentNo: selectedDepartmentsData.departmentNo.toString()
            }
          };
          this.$api.deleteDepartments(deleteRequest).then(() => {
            this.$api.getDepartments().then((ret) => {
              if (ret && ret.data) {
                this.GetDepartmentsData = ret.data;
                this.addedDepartmentGroup = null;
                this.selectedDepartmentsData = this.GetDepartmentsData[0];
                this.indexGetDepartmentsService = 0;
                this.formEdited = false;
              }
            });
          })
          .catch(e => {
            if(e.data.code === 'D0001'){
              alert(e.data.message);
              return false;
            }
          })
        } else {
          this.addedDepartmentGroup = null;
        }
      }
    } else {
      this.addedDepartmentGroup = null;
      this.selectedDepartmentsData = this.GetDepartmentsData[0];
      this.indexGetDepartmentsService = 0;
      this.formEdited = false;
    }
  }
  private departmentNameChange() {
    if((this.selectedDepartmentsData as any).departmentName){
      const reg = new RegExp(pattern['no-symbol'], 'g');
      (this.selectedDepartmentsData as any).departmentName = (this.selectedDepartmentsData as any).departmentName.replace(reg, '')
    }
    // qa667 input框是否为空 为空的话显示默认
    if ((this.selectedDepartmentsData as any).departmentName === '') {
      alert(this.$t('ADMIN_DEPARTMENT_NAME_ERROR'));
      (this.selectedDepartmentsData as any).departmentName = this.selectStatus.departmentName;
    }
  }
  private keyupDepart(e){//todo
    const value = e.target.value;
    // const validate = /[\,\.\-\_a-zA-Zㄱ-힣]/g
    const validate = new RegExp(pattern['no-symbol'], 'g').test(value);
    if(validate){
      this.errorDepart = true;
    }else{
      this.errorDepart = false;
    }
    if(!value) {     
      this.errorDepart = false;
    }
    e.target.value = value.replace(new RegExp(pattern['no-symbol'], 'g'),'');
    (this.selectedDepartmentsData as any).departmentName = e.target.value;
    
  }
  private blurDepart(e){
    const value = e.target.value;
    // const validate = /[\,\.\-\_a-zA-Zㄱ-힣]/g
    const validate = new RegExp(pattern['no-symbol'], 'g').test(value);
    if(validate){
      this.errorDepart = true;
    }else{
      this.errorDepart = false;
    }
    if(!value) {
      alert(this.$t('ADMIN_DEPARTMENT_NAME_ERROR'));
      this.$nextTick(() => {
         (this.selectedDepartmentsData as any).departmentName = this.selectStatus.departmentName;
      });
     
      this.errorDepart = false;
    }
    e.target.value = value.replace(new RegExp(pattern['no-symbol'], 'g'),'');
    (this.selectedDepartmentsData as any).departmentName = e.target.value;
    this.errorDepart = false;
  }
  dblclickDepartnmentName(index:number){
    this.displayInput['tui-tree-input'+index]=true
    this.$forceUpdate();
    this.$nextTick(()=>{
      $(this.$refs['tui-tree-input'+index][0]).focus();
    })
  }
  blurDepartnmentName(index:number, e){
    this.blurDepart(e);
    this.errorDepart = false;
    this.displayInput['tui-tree-input'+index]=false;
    this.$forceUpdate();
  }
}
